import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import CompareBar from "@/components/CompareBar";
import Home from "@/pages/Home";
import CoachProfile from "@/pages/CoachProfile";
import ProgressFeed from "@/pages/ProgressFeed";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import StoryShare from "@/pages/StoryShare";
import Compare from "@/pages/Compare";
import BecomeCoach from "@/pages/BecomeCoach";
import Admin from "@/pages/Admin";

function AppRouter() {
    const location = useLocation();
    // Detect OAuth callback via URL fragment synchronously during render
    if (location.hash?.includes("session_id=")) {
        return (
            <>
                <Header />
                <AuthCallback />
            </>
        );
    }
    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/coach/:id" element={<CoachProfile />} />
                <Route path="/feed" element={<ProgressFeed />} />
                <Route path="/story/:id" element={<StoryShare />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/devenir-coach" element={<BecomeCoach />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/login" element={<Login />} />
            </Routes>
            <CompareBar />
        </>
    );
}

export default function App() {
    return (
        <div className="App min-h-screen bg-[#0A0A0A]">
            <HelmetProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <AppRouter />
                        <Toaster
                            theme="dark"
                            position="bottom-right"
                            toastOptions={{
                                style: {
                                    background: "#121212",
                                    color: "#fff",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    borderRadius: 0,
                                },
                            }}
                        />
                    </AuthProvider>
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}
